import React from "react";
import { useNavigate } from "react-router-dom";

const Navigationbar = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-black text-white w-full text-sm font-medium">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-12 py-3 sm:flex flex-col md:flex-row justify-between items-center space-y-1 md:space-y-0 md:space-x-6 text-center hidden">
        <span>
          K4-891, 2nd Floor, Kalinga Vihar, Bhubaneswar, Odisha, 751019
        </span>
        <span className="hidden md:inline-block border-l border-orange-500 h-4"></span>
        <span>+91(9777)772-782</span>
        <span className="hidden md:inline-block border-l border-orange-500 h-4"></span>
        <span>+91(9777)772-782</span>
        <span className="hidden md:inline-block border-l border-orange-500 h-4"></span>
        <span>bricknbar1@gmail.com</span>
      </div>
      <div className="w-full mx-auto px-6 py-1 flex justify-center items-center text-center sm:hidden text-[6px] space-x-6 ">
        <span>
          K4-891, 2nd Floor, Kalinga Vihar, Bhubaneswar, Odisha, 751019
        </span>
        <button
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold text-[6px] px-3 py-1 rounded-full shadow-md transition duration-300 ease-in-out"
          onClick={() => {
            navigate("/contact");
          }}
        >
          Enquiry now
        </button>
      </div>
    </div>
  );
};

export default Navigationbar;
